import React from "react";
import { Form, Button } from "react-bootstrap";

export default function SaveData({ Save }) {
  return (
    <table className="halfTable">
      <thead className="halfTableheadborder">
        <tr>
          <th className="col-1 normalBorder curve">
            <h4 className="me-1 mt-2">Save Data</h4>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="col-4">
            <Button className="saveButton" onClick={Save}>
              Save
            </Button>
          </td>
        </tr>
      </tbody>
      <tfoot className="foot halfFoot hideBorders">
        <tr>
          <td></td>
        </tr>
      </tfoot>
    </table>
  );
}
